import React from "react";
import { Route } from "react-router-dom";
import OrdersContext from "./modules/orders/OrdersContext";
import StocksList from "./modules/stocks/StockList";
import ProductList from "./modules/products/ProductList";
import OrderContext from "./modules/orders/OrderContext";

export default [
  <Route exact path="/orders" component={OrdersContext} /> ,
  <Route exact path="/orders/create" component={OrderContext} /> ,
  <Route exact path="/ordersEdit/:id" component={OrderContext} /> ,
  <Route path="/stock" component={StocksList} />,
  <Route path="/products" component={ProductList} />
];
